import getEnv from '@wetransfer/transfer/config/env';
import Privacy from '@wetransfer/transfer/modules/privacy';
import TermsAndConditions from '@wetransfer/transfer/modules/terms-and-conditions';
import { actions } from '@wetransfer/transfer/store/action/session';

export default function (state = {}, action) {
  const env = getEnv();
  const { type } = action;

  switch (type) {
    case actions.ACCEPT_TERMS_CONDITIONS:
      return {
        ...state,
        tandc: TermsAndConditions.areAccepted(),
      };

    case actions.UPDATE_PRIVACY:
      return {
        ...state,
        privacy: {
          ...state.privacy,
          notified: Privacy.userHasClosedBanner(),
          allowTracking: Privacy.userAllowsTracking(),
        },
      };

    case actions.LANGUAGE_SET:
      return {
        ...state,
        language: action.language,
      };

    case actions.REDIRECT_SET:
      return {
        ...state,
        redirect: action.path,
      };

    case actions.REDIRECT_CLEAR:
      delete state['redirect'];

      return {
        ...state,
      };

    case actions.REQUIRE_REFRESH:
      return {
        ...state,
        incompatible_version: true,
      };

    case actions.SET_DOMAIN_USER_ID:
      return {
        ...state,
        domainUserId: action.id,
      };

    case actions.SET_MAX_FILE_SIZES:
      return {
        ...state,
        assetUpload: action.fileSizes,
      };

    case actions.SET_TRANSFER_EXPIRY_OPTIONS:
      return {
        ...state,
        transferExpiryOptions: action.transferExpiryOptions,
      };

    case actions.SET_REGION:
      return {
        ...state,
        region: {
          // If we somehow cant figure out where someone is from (like on dev),
          // the api returns NULL on these fields. Because we do not allow
          // these fields to actually be null on like the pricing page we
          // use these fallbacks
          country:
            action.region.country ?? env.NEXT_PUBLIC_FALLBACK_COUNTRY_CODE,
          continent:
            action.region.continent ?? env.NEXT_PUBLIC_FALLBACK_CONTINENT_CODE,
          currency:
            action.region.currency ?? env.NEXT_PUBLIC_FALLBACK_CURRENCY_CODE,
        },
      };

    case actions.SET_COOKIE_DOMAIN:
      return {
        ...state,
        domain: action.cookieDomain,
      };
  }

  return state;
}
